import React from "react";
import { Helmet } from "react-helmet-async";
import SEOPortal from "../component/SEOPortal/SEOPortal";

const SEOPortalPage = () => {
  return (
    <>
      <Helmet>
        <title>SEO Portal - Polani Travels</title>
        <meta name="description" content="Manage SEO settings for all pages" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="seo-portal-page">
        <SEOPortal />
      </div>
    </>
  );
};

export default SEOPortalPage;
